import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";

import { getCategoryDetails } from "../../../../../services/Admin/MenuApi";
import { resolveImageUrl } from "../../../../../services/indexMediaBaseUrl";

const getVisibleProducts = (products) =>
  Array.isArray(products)
    ? products.filter((product) => Number(product?.status) !== 0)
    : [];

const CategoryDetailsDialog = ({ open, onClose, categoryId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [category, setCategory] = useState(null);

  const fetchDetails = async (id) => {
    if (!id) return;
    setLoading(true);
    setError("");
    try {
      const res = await getCategoryDetails(id);
      setCategory(res?.data || null);
    } catch (err) {
      setError(err?.message || "Failed to load category details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) fetchDetails(categoryId);
  }, [open, categoryId]);

  const visibleProducts = getVisibleProducts(category?.products);

  return (
    <Dialog open={Boolean(open)} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>تفاصيل الفئة</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ color: "error.main", p: 2 }}>{String(error)}</Box>
        ) : !category ? (
          <Box sx={{ p: 2 }}>لا توجد بيانات</Box>
        ) : (
          <Box>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
              <Box sx={{ width: 120, height: 120, flex: "0 0 120px" }}>
                <Card>
                  <CardMedia
                    component="img"
                    height="120"
                    image={resolveImageUrl(category.image)}
                    alt={category.name}
                  />
                </Card>
              </Box>
              <Box>
                <Typography variant="h6">{category.name}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {category.description}
                </Typography>
                <Typography variant="caption" sx={{ display: "block", mt: 1 }}>
                  الحالة: {category.status ? "مفعل" : "غير مفعل"}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                الأصناف في هذه الفئة
              </Typography>
              {visibleProducts.length > 0 ? (
                <Grid container spacing={2}>
                  {visibleProducts.map((p) => (
                    <Grid item key={p.id} xs={12} sm={6} md={4}>
                      <Card>
                        {p.image ? (
                          <CardMedia
                            component="img"
                            height="140"
                            image={resolveImageUrl(p.image)}
                            alt={p.name}
                          />
                        ) : null}
                        <CardContent>
                          <Typography variant="subtitle2" fontWeight="bold">
                            {p.name}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {p.description}
                          </Typography>
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            السعر: {p.price}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Box sx={{ p: 1 }}>لا توجد أصناف في هذه الفئة.</Box>
              )}
            </Box>
          </Box>
        )}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button onClick={onClose}>إغلاق</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CategoryDetailsDialog;
